import type { ReactNode } from 'react';

const MD_LINK_RE = /\[([^\]\n]+)\]\(([^()\s]+)\)/g;
const INTERNAL_PATH_RE = /^\/(?!\/)[A-Za-z0-9\-._~/%?#=&+]*$/;
const AIPECES_URL_RE = /^https:\/\/(www\.)?aipeces\.com\//;

function isAllowedHref(href: string): boolean {
    return INTERNAL_PATH_RE.test(href) || AIPECES_URL_RE.test(href);
}

export function renderInlineMarkdown(text: string): ReactNode[] {
    const src = text ?? '';
    const nodes: ReactNode[] = [];
    let cursor = 0;
    let i = 0;
    MD_LINK_RE.lastIndex = 0;
    let match: RegExpExecArray | null;
    while ((match = MD_LINK_RE.exec(src)) !== null) {
        if (match.index > cursor) {
            nodes.push(src.slice(cursor, match.index));
        }
        const label = match[1];
        const href = match[2];
        if (isAllowedHref(href)) {
            nodes.push(
                <a
                    key={`md-${i++}`}
                    href={href}
                    className="text-sky-700 underline underline-offset-2"
                    target="_blank"
                    rel="noreferrer"
                >
                    {label}
                </a>,
            );
        } else {
            nodes.push(match[0]);
        }
        cursor = match.index + match[0].length;
    }
    if (cursor < src.length) nodes.push(src.slice(cursor));
    return nodes;
}

export function markdownParagraphs(text: string): string[] {
    return String(text || '')
        .split(/\n{2,}/)
        .map((p) => p.trim())
        .filter(Boolean);
}
